import React, { ReactElement, useEffect, useState } from "react";
import { closeWindow, openUrl } from "../../utils/common";
import { navHide } from "../../utils/common";
import { toShare, toBePartNer } from "../next-station-map/config";

const UA = navigator.userAgent || "";
const isXPApp = /xiaopeng/i.test(UA); // 小鹏app


const App = (): ReactElement => {
  const goBack = () => {
    console.log('goBack');
    closeWindow();
  };
  const toRule = () => {
    openUrl("https://events.xiaopeng.com/ggbtk7.html?ch=04474&ps=event");
  };
  const toMap = () => {
    window.location.href = "/apps/charge-web/next-station-map.html";
  };

  useEffect(() => {
    navHide();
  });
  
  return (
    <div className={`content ${ isXPApp ? '' : 'content-top'}`}>
      <div className="nav-bar">
        {isXPApp ? <><div className="nav-bar-left" onClick={goBack}></div><div className="nav-bar-right" onClick={toShare}></div></> : <></> }  
      </div>
      <div className="top-background"></div>
      <div className="top-botton" onClick={toRule}>规则详情</div>

      <div className="description">
        <div className="description-content">
          <div className="description-content-title">
            <div className="description-icon-left"></div>
            <div className="description-title-1"></div>
            <div className="description-icon-right"></div>
          </div>
          <div className="description-content-text">
            为了更好的满足鹏友们的补能需求，小鹏充电现面向所有用户进行建站心愿征集，诚邀各位鹏友提出您的建站意见，我们将倾听每一位鹏友的心声
          </div>
          <div className="description-button-black" onClick={toMap}>
            进入心愿选址
          </div>
        </div>
        <div className="description-content description-margin">
          <div className="description-content-title">
            <div className="description-icon-left"></div>
            <div className="description-title-2"></div>
            <div className="description-icon-right"></div>
          </div>
          <div className="description-content-text">
            小鹏充电现开放全国超快充站点合作加盟
            <br />
            如果您有超快充相关资源，点击下方按钮与我们合作
          </div>
          <div className="description-button-white" onClick={toBePartNer}>
            我已有现成资源合作
          </div>
        </div>
        <div className="description-bottom"></div>
      </div>
    </div>
  );
};

export default App;
